<template>
  <div>

    <BackButton v-if="$route.name !== 'blacklists'" :namedRoutes="{ blacklists: $t('common.blacklist'), blacklist: $t('blacklist.title')}"></BackButton>

    <add-blacklist-view v-if="$route.name !== 'blacklist'"></add-blacklist-view>
    <blacklist-details v-if="$route.name === 'blacklist'" />

    <BackButton v-if="$route.name !== 'blacklists'" :namedRoutes="{ blacklists: $t('common.blacklist'), blacklist: $t('blacklist.title')}"></BackButton>

  </div>
</template>

<script>
import BackButton from 'common/BackButton';
import BlacklistDetails from 'blacklist/BlacklistDetails';
import AddBlacklistView from './AddBlacklistView';

export default {
  components: {
    BackButton,
    BlacklistDetails,
    AddBlacklistView,
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/blacklist/MainView.vue